(function() {
    angular
        .module('rlt')
        .service('DataDrivenDialogService', DataDrivenDialogService)

    DataDrivenDialogService.$inject = [];

    function DataDrivenDialogService() {

        var svc = this;

        svc.register = register;
        svc.show = show;
        svc.onSubmit = onSubmit;
        svc.onCancel = onCancel;
        svc.dialogs = {};


        function register( name ) {

            svc.dialogs[name] = {};

            svc.dialogs[name].isVisible = false;
            svc.dialogs[name].callback = false;

            svc.dialogs[name].data = false;

            return svc.dialogs[name];
        }

        function show( name, data, callback ) {
            svc.dialogs[name].data = data;
            svc.dialogs[name].callback = callback;
            svc.dialogs[name].isVisible = true;
        }

        function onSubmit( name, result ) {
            svc.dialogs[name].isVisible = false;
            svc.dialogs[name].callback( result );
        }

        function onCancel( name ) {
            svc.dialogs[name].isVisible = false;
        }
    }
})();

